import { type SupportedNetworkName } from '@pkg/types';

export enum CompetitionCollectionStatus {
    Normal = 'Normal',
    Banned = 'Banned',
    UnderInvestigation = 'UnderInvestigation',
}

export interface CompetitionCollection {
    id: string;
    slug: string;
    status: CompetitionCollectionStatus;
    created_at: string;
    updated_at?: string;
    network: SupportedNetworkName;
}

export type CompetitionCollectionPatchParams = {
    status: CompetitionCollection['status'];
};
